"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardColumn = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@dnd-kit/core");
const core_2 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const BoardItem_1 = require("./BoardItem");
const BoardItemWithSubTask_1 = require("./BoardItemWithSubTask");
const BoardColumn = props => {
    var _a;
    const { column, manager, dragTask, onSelectTask } = props;
    const { findEvent } = manager;
    const { state, tasks } = column;
    const title = state.name;
    const [eventName, setEventName] = (0, react_1.useState)('?');
    const stateColor = (_a = state.meta) === null || _a === void 0 ? void 0 : _a.color;
    const color = stateColor && typeof stateColor === 'object' ? stateColor : undefined;
    // if event transitions include the title, enable drop
    const event = (0, react_1.useMemo)(() => {
        return dragTask && findEvent(dragTask.status, title);
    }, [dragTask, title, findEvent]);
    const canDrop = !!event;
    const { isOver, setNodeRef } = (0, core_1.useDroppable)({
        id: title,
        disabled: !canDrop
    });
    const classes = ['card-container'];
    isOver && classes.push('over');
    canDrop && classes.push('droppable');
    (0, react_1.useEffect)(() => {
        (event === null || event === void 0 ? void 0 : event.name) && setEventName(event.name);
    }, [event]);
    return (react_1.default.createElement(core_2.Paper, { className: 'column' },
        react_1.default.createElement(core_ui_1.CardTitle, { style: canDrop ? color : undefined }, !canDrop ? (title) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("strong", null, eventName),
            " (",
            title,
            ")"))),
        react_1.default.createElement("div", { ref: setNodeRef, className: classes.join(' ') }, tasks.map(task => {
            const hasSubTask = (task.children || []).length > 0;
            const itemProps = {
                task,
                isLoading: manager === null || manager === void 0 ? void 0 : manager.isLoading(task.id),
                onClick: () => onSelectTask === null || onSelectTask === void 0 ? void 0 : onSelectTask(task)
            };
            return (react_1.default.createElement(react_1.Fragment, { key: task.id }, !hasSubTask ? (react_1.default.createElement(BoardItem_1.DraggableBoardItem, Object.assign({}, itemProps))) : (react_1.default.createElement(BoardItemWithSubTask_1.DraggableBoardItemWithSubTask, Object.assign({}, itemProps)))));
        }))));
};
exports.BoardColumn = BoardColumn;
exports.default = exports.BoardColumn;
//# sourceMappingURL=BoardColumn.js.map